<template>
  <v-row no-gutters class="fill-height flex-column" style="overflow-y: auto; overflow-x: hidden;">
    <v-col cols="12">
      <card-title-row :straightTitle="$i18n.t('sidebar.zdmSelectionReport.title')" class="py-6"> </card-title-row>
      <sidebar-row>
        <base-button-subheader subheader-translation-path="sidebar.zdmSelectionReport.selectObjectsSubtitle">
          <dots-menu :items="dotsItems" @multiple="turnOnDrawing('multiple')" @freehand="turnOnDrawing('freehand')">
            <template #activator="{ on }">
              <base-button
                :disabled="isDone"
                v-on="getButtonListeners(on)"
                class="mr-0"
                translation-path="sidebar.zdmSelectionReport.selectObjects"
                :button-style="buttonStyle"
              >
              </base-button>
            </template>
          </dots-menu>
        </base-button-subheader>
      </sidebar-row>
      <sidebar-row v-if="isDone" class="py-6">
        <v-row>
          <v-col cols="auto">
            <base-button
              :loading="loading"
              class="mr-0"
              translation-path="sidebar.zdmSelectionReport.generateReport"
              @click="handleGenerateReport"
            ></base-button>
          </v-col>
          <v-col cols="auto">
            <base-button
              cancel
              :disabled="loading"
              translation-path="sidebar.zdmSelectionReport.clearSelection"
              @click="clearSelection"
            ></base-button>
          </v-col>
        </v-row>
      </sidebar-row>
    </v-col>
  </v-row>
</template>

<script>
import CardTitleRow from '@/components/CardTitleRow';
import SidebarRow from '@/components/SidebarRow';
import DotsMenu from '@/components/DotsMenu';

import { createBox } from 'ol/interaction/Draw';

import { call } from 'vuex-pathify';

export default {
  name: 'ZDMSelectionReportSidebar',
  components: {
    CardTitleRow,
    SidebarRow,
    DotsMenu,
  },
  data: () => ({
    loading: false,
    payload: {
      geometry: undefined,
      srid: undefined,
    },
    isButtonActive: false,
    isDone: false,
    isDrawing: false,
    dotsItems: [
      {
        name: 'multiple',
      },
      {
        name: 'freehand',
      },
    ],
    currentTaskId: null,
  }),
  computed: {
    buttonStyle() {
      return this.isButtonActive
        ? {
            backgroundColor: '#E8F0FE !important',
            border: '1px solid rgba(26, 115, 232, 0.3) !important',
            color: this.$_colors.primary,
          }
        : {
            backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
            border: '1px solid rgba(0, 0, 0, 0.2) !important',
            color: '#61646D',
          };
    },
  },
  methods: {
    getObjectsReportId: call('zdm/getObjectsReportId'),
    checkObjectsReportStatus: call('celeryTasks/getCeleryTaskStatus'),
    generateObjectsReport: call('celeryTasks/getCeleryTaskResult'),
    cancelModernizationReport: call('celeryTasks/stopCeleryTask'),
    turnOffSelecting() {
      this.isDrawing = false;
      this.isButtonActive = false;
      this.$root.$emit('selection-action');
    },
    getButtonListeners(on) {
      return this.isButtonActive
        ? {
            click: this.turnOffSelecting,
          }
        : on;
    },
    clearSelection() {
      this.isButtonActive = false;
      this.isDone = false;
      this.$root.$emit('clearSidebarGeometry');
    },
    onDrawend(e) {
      this.isDrawing = false;
      this.isDone = true;
      this.payload = {
        srid: this.$_config.defaultEpsg.split(':')[1],
        geometry: {
          type: 'Feature',
          geometry: {
            type: e.feature.getGeometry().getType(),
            coordinates: e.feature.getGeometry().getCoordinates(),
          },
          properties: {},
        },
      };
    },
    turnOnDrawing(type) {
      this.isDrawing = true;
      this.isButtonActive = true;
      this.$root.$emit('drawSidebarGeometry', {
        drawendCallback: this.onDrawend,
        geometryFunction: type === 'multiple' ? createBox() : null,
        geometryType: 'polygon',
        isInitSnapping: false,
        freehand: type === 'freehand' ? true : false,
      });
    },
    async handleGenerateReport() {
      try {
        this.loading = true;
        const taskId = await this.getObjectsReportId(this.payload);
        this.currentTaskId = taskId;
        this.$store.set('snackbar/PUSH_MESSAGE!', {
          message: this.$i18n.t('snackbar.generatingReport'),
        });
        const checkerId = Date.now();
        this.$store.set('asyncStatusChecker/PUSH_STATUS_CHECKER!', {
          id: checkerId,
          checkingStatusFunction: async () => {
            const status = await this.checkObjectsReportStatus(taskId);
            if (['REVOKED', 'FAILURE'].includes(status)) {
              this.$store.set('asyncStatusChecker/REMOVE_STATUS_CHECKER_BY_ID!', checkerId);
              return 'cancel';
            }
            return status === 'SUCCESS';
          },
          successCallback: async () => {
            this.$store.set('asyncStatusChecker/REMOVE_STATUS_CHECKER_BY_ID!', checkerId);
            await this.generateObjectsReport({ id: taskId });
            this.currentTaskId = null;
            this.loading = false;
          },
          interval: 5000,
        });
      } catch (error) {
        this.currentTaskId = null;
        this.loading = false;
        console.log('error', error);
      }
    },
  },
  beforeDestroy() {
    if (this.currentTaskId) {
      this.cancelModernizationReport(this.currentTaskId);
    }
    this.clearSelection();
    if (this.isDrawing) {
      this.turnOffSelecting();
    }
  },
};
</script>
